import { Typography } from '@mui/material';
import React from 'react';
import {
  DateField,
  Edit as Show,
  Labeled,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  useTranslate,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';

export const PaymentShow = () => {
  const translate = useTranslate();

  return (
    <Show>
      <SimpleShowLayout>
        <Typography>
          {translate('resources.payments.name', { smart_count: 1 })}
        </Typography>

        <Labeled label="resources.payments.fields.created_at">
          <DateField source="MetaData.CreateTime" />
        </Labeled>
        <Labeled label="resources.payments.fields.method">
          <ReferenceField
            source="PaymentMethodRef.value"
            reference="paymentmethods"
            link={false}
          >
            <TextField source="Name" />
          </ReferenceField>
        </Labeled>
        <Labeled label="resources.payments.fields.amount">
          <QuickbooksPriceField source="TotalAmt" />
        </Labeled>
        <Labeled label="resources.payments.fields.reference">
          <TextField source="PaymentRefNum" />
        </Labeled>
        <Labeled label="resources.payments.fields.payment_date">
          <DateField source="TxnDate" />
        </Labeled>
        <Labeled label="resources.payments.fields.note">
          <TextField source="PrivateNote" />
        </Labeled>
      </SimpleShowLayout>
    </Show>
  );
};
